import { max, min, scaleBand,  } from "d3"
import { addDays } from "date-fns";

import { EntregasBars } from "./EntregasBars";
import { OperacoesExternas } from "./OperacoesExternas";



export function ObrasBars({ obras, xScale, yScale, maquinasBarHeight, margins }: any) {

    let prevY = 0;

    const obraYScale = (entregas: any[], y0: number, y1: number) => scaleBand()
        .domain(entregas.map((e: any) => e.id))
        .range([y0, y1])


    const getColotByEstado = ( obra: any ) => {
        const state = obra.state;
        console.log("State is: ", state);
        switch(state) {
            case 'Por iniciar':
                return 'fill-cyan-500';
            case 'Em andamento':
                return 'fill-yellow-400'
            default:
                return 'gray';
        }
    }


    return (
        <>
            {obras.map((obra: any, i : number) => {

                const start: any = min(obra.entregas.map((e: any) => e.startingDate));
                const end: any = max(obra.entregas.map((e: any) => e.realDeliveryDate));
                const x = xScale(start);
                const obrasBarHeight = obra.entregas.reduce((a: number, c: any) => a + ([...new Set(c.maquinasGantt.map((mg: any) => mg.maquina.id))]).length, 0) * maquinasBarHeight;
                let y = i > 0 ? prevY + 5 : yScale(obra.number);

                prevY = y + obrasBarHeight;
                
                return (
                    <svg key={obra.id}>

                        <rect
                            x={x}
                            y={y + margins.top}
                            width={xScale(addDays(end, 1) ) - xScale(start)}
                            height={obrasBarHeight}
                            className={`${getColotByEstado(obra)}`}
                            stroke={'black'}
                            opacity={'0.6'}
                            strokeWidth={2}
                            strokeDashoffset={1}
                            rx={5}
                            strokeLinecap="round"
                            strokeDasharray="5,10,5"
                        />
                        
                        
                        <EntregasBars maquinasBarHeight={maquinasBarHeight} entregas={obra.entregas} xScale={xScale} yScale={obraYScale(obra.entregas, y, y + obrasBarHeight)} margins={margins}/>

                        <text className="text-xl font-bold" x={xScale(start) + 5} y={y + obrasBarHeight - 5 + margins.top}>{obra.number}</text>
                        

                        <OperacoesExternas obra={obra} xScale={xScale} y={y} obrasBarHeight={obrasBarHeight} margins={margins}/>

                    </svg>
                )

            })}
        </>
    )





}